import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';
import _ from 'lodash';
import { DiscountValues, PersonTypeModel } from '../types/index';

PricingDiscountsAddPersonTypeModalController.$inject = [
  '$scope',
  '$uibModalInstance',
  'discount',
  'personTypes',
  'tab',
  'discountTypes',
];

function PricingDiscountsAddPersonTypeModalController(
  $scope: IScope & { pricingDiscountsAddPersonTypeModal: TODO },
  $uibModalInstance: UIBModal<TODO>,
  discount: TODO,
  personTypes: TODO,
  tab: string,
  discountTypes: TODO
) {
  const ctrl = {
    model: {} as PersonTypeModel,

    displayName: '',

    personTypeList: {},

    personTypeGroup: tab,

    discountTypes: discountTypes,

    init: function () {
      ctrl.model = _.cloneDeep(discount);
      ctrl.personTypeList = ctrl.processPersonTypes();
    },

    processPersonTypes: function () {
      const values = ctrl.model.values;
      return _(personTypes)
        .map((item) => {
          item.status = item.active ? 'active' : 'deactivated';
          item.selected = !!values.find((val) => val.personTypeId === item.id);
          item.typeParsed = item.type.toLowerCase();

          return item;
        })
        .groupBy((item) => item.typeParsed)
        .mapValues((group) => {
          return _(group)
            .groupBy((item) => item.status)
            .mapValues((group) => {
              return {
                show: true,
                fields: group,
              };
            })
            .value();
        })
        .value();
    },

    getList: function () {
      return ctrl.personTypeList[ctrl.personTypeGroup];
    },

    toggleColumn: function (item) {
      item.selected = !item.selected;

      ctrl.toggleDiscountValues(item);
    },

    toggleDiscountValues: function (item) {
      const discountValue: DiscountValues = {
        personTypeId: item.id,
        discountType: 'PercentageBased',
        displayValue: '0%',
        value: '0.00',
        personType: item,
        selectedDiscountType: ctrl.discountTypes[0],
      };

      const itemIndex = ctrl.model.values.findIndex(function (val) {
        return val.personTypeId === item.id;
      });

      if (itemIndex >= 0) {
        ctrl.model.values.splice(itemIndex, 1);
      } else {
        ctrl.model.values.push(discountValue);
      }
    },

    close: function () {
      $uibModalInstance.dismiss('cancel');
    },

    continue: function () {
      this.model.values = _.orderBy(this.model.values, ['personType.name', 'asc']);
      $uibModalInstance.close(ctrl.model);
    },
  };

  $scope.pricingDiscountsAddPersonTypeModal = ctrl;
  ctrl.init();
}

export const PricingDiscountsAddPersonTypeModalControllerModule = angular
  .module('acme.view.application.pricing.discounts.addPersonTypeModal.controllers', [])
  .controller('PricingDiscountsAddPersonTypeModalController', PricingDiscountsAddPersonTypeModalController).name;
